import React, { useEffect, useState } from "react";
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
    LineChart, Line, CartesianGrid, Legend
} from "recharts";
import { ResponsiveHeatMap } from "@nivo/heatmap";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

// 📌 Mock API function (replace with real API calls)
const fetchAnalytics = async () => {
    return {
        topScore: 50,
        leastScore: 12,
        avgScore: 34,
        top10: [
            { rank: 1, name: "Sandeep Kumar", score: 50, accuracy: "100%", speed: "30s" },
            { rank: 2, name: "Amit", score: 48, accuracy: "96%", speed: "35s" },
            { rank: 3, name: "Ravi", score: 46, accuracy: "92%", speed: "33s" }
        ],
        subjectAvg: [
            { subject: "Hindi", avg: 8 },
            { subject: "Maths", avg: 7 },
            { subject: "English", avg: 9 },
        ],
        questionAvg: [
            { question: "Q1", avg: 0.8 },
            { question: "Q2", avg: 0.6 },
            { question: "Q3", avg: 0.9 },
            { question: "Q4", avg: 0.5 },
            { question: "Q5", avg: 1 },
        ],
        subjectComparison: [
            { id: "Hindi", data: [{ x: "Top", y: 95 }, { x: "Avg", y: 65 }, { x: "Least", y: 35 }] },
            { id: "Maths", data: [{ x: "Top", y: 88 }, { x: "Avg", y: 58 }, { x: "Least", y: 20 }] },
            { id: "English", data: [{ x: "Top", y: 92 }, { x: "Avg", y: 60 }, { x: "Least", y: 40 }] },
        ],
        questionComparison: [
            { id: "Q1", data: [{ x: "Top", y: 1 }, { x: "Avg", y: 0.6 }, { x: "Least", y: 0.2 }] },
            { id: "Q2", data: [{ x: "Top", y: 1 }, { x: "Avg", y: 0.7 }, { x: "Least", y: 0.3 }] },
            { id: "Q3", data: [{ x: "Top", y: 1 }, { x: "Avg", y: 0.8 }, { x: "Least", y: 0.4 }] },
        ],
        bestSubject: "English",
        worstSubject: "Maths",
        correctIncorrect: [
            { question: "Q1", correct: 45, incorrect: 5 },
            { question: "Q2", correct: 40, incorrect: 10 },
            { question: "Q3", correct: 47, incorrect: 3 },
            { question: "Q4", correct: 30, incorrect: 20 },
            { question: "Q5", correct: 50, incorrect: 0 },
        ],
        timeSubject: [
            { subject: "Hindi", time: 60 },
            { subject: "Maths", time: 120 },
            { subject: "English", time: 80 },
        ],
        timeQuestion: [
            { question: "Q1", time: 33 },
            { question: "Q2", time: 14 },
            { question: "Q3", time: 34 },
            { question: "Q4", time: 178 },
            { question: "Q5", time: 106 },
        ]
    };
};

const ExamAnalytics = ({ edata = null }) => {
    const [data, setData] = useState(edata);

    // useEffect(() => {
    //     fetchAnalytics().then(setData);
    // }, []);

    return (
        <>
            {/* Top / Least / Average */}
            <div className="col-span-1 mb-4 flex flex-col md:flex-row md:items-end md:justify-between gap-2">
                <div>
                    <h1 className="text-2xl md:text-3xl font-bold">Exam Analytics</h1>
                    <p className="text-gray-500">{data.examname} • Test: {data.testname}</p>
                </div>
            </div>
            <div className="col-span-2 flex gap-6">
                <div className="bg-white shadow p-4 rounded-2xl flex-1 text-center">
                    <h3 className="text-lg font-bold">Top Score</h3>
                    <p className="text-2xl">{data.topScore}</p>
                </div>
                <div className="bg-white shadow p-4 rounded-2xl flex-1 text-center">
                    <h3 className="text-lg font-bold">Least Score</h3>
                    <p className="text-2xl">{data.leastScore}</p>
                </div>
                <div className="bg-white shadow p-4 rounded-2xl flex-1 text-center">
                    <h3 className="text-lg font-bold">Average Score</h3>
                    <p className="text-2xl">{data.avgScore}</p>
                </div>
            </div>

            {/* Top 10 Leaderboard */}
            <div className="col-span-2 bg-white shadow rounded-2xl p-4">
                <h3 className="text-lg font-bold mb-2">Top 10 Students</h3>
                <table className="w-full border">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="p-2">Rank</th>
                            <th className="p-2">Name</th>
                            <th className="p-2">Roll No</th>
                            <th className="p-2">Score</th>
                            <th className="p-2">Accuracy</th>
                            <th className="p-2">Speed</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.top10.map((s, i) => (
                            <tr key={i} className="border-t text-center">
                                <td>{s.rank}</td>
                                <td>{s.name}</td>
                                <td>{s.roll_no}</td>
                                <td>{s.score}</td>
                                <td>{s.accuracy}</td>
                                <td>{s.speed}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Subject Avg */}
            <div className="bg-white shadow rounded-2xl p-4">
                <h3 className="text-lg font-bold mb-2">Subject-wise Average</h3>
                <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={data.subjectAvg}>
                        <XAxis dataKey="subject" />
                        <YAxis />
                        <Tooltip />
                        <Bar dataKey="avg" fill="#8884d8" />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* Question Avg */}
            <div className="bg-white shadow rounded-2xl p-4">
                <h3 className="text-lg font-bold mb-2">Question-wise Average</h3>
                <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={data.questionAvg}>
                        <XAxis dataKey="question" />
                        <YAxis />
                        <Tooltip />
                        <Bar dataKey="avg" fill="#82ca9d" />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* Subject Heatmap */}
            <div className="bg-white shadow rounded-2xl p-4 col-span-2">
                <h3 className="text-lg font-bold mb-2">Subject-wise Comparison (Top, Avg, Least)</h3>
                <div style={{ height: 300 }}>
                    <ResponsiveHeatMap
                        data={data.subjectComparison}
                        margin={{ top: 30, right: 90, bottom: 60, left: 90 }}
                        axisTop={null}
                        axisRight={null}
                        enableLabels={true}
                        labelTextColor={(cell) => {
                            // cell.color gives the background color
                            // you can calculate brightness
                            const [r, g, b] = cell.color.match(/\d+/g).map(Number);
                            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
                            return brightness > 128 ? '#000' : '#fff'; // black on light, white on dark
                        }}
                    />
                </div>
            </div>

            {/* Question Heatmap */}
            <div className="bg-white shadow rounded-2xl p-4 col-span-2">
                <h3 className="text-lg font-bold mb-2">Question-wise Comparison</h3>
                <div style={{ height: 300 }}>
                    <ResponsiveHeatMap
                        data={data.questionComparison}
                        margin={{ top: 30, right: 90, bottom: 60, left: 90 }}
                        axisTop={null}
                        axisRight={null}
                        // Show labels inside cells
                        enableLabels={true}
                        labelTextColor={(cell) => {
                            // cell.color gives the background color
                            // you can calculate brightness
                            const [r, g, b] = cell.color.match(/\d+/g).map(Number);
                            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
                            return brightness > 128 ? '#000' : '#fff'; // black on light, white on dark
                        }}
                    />
                </div>
            </div>

            {/* Best & Worst */}
            <div className="bg-white shadow rounded-2xl p-4 text-center">
                <h3 className="text-lg font-bold">Best Subject</h3>
                <p className="text-2xl text-green-600">{data.bestSubject}</p>
            </div>
            <div className="bg-white shadow rounded-2xl p-4 text-center">
                <h3 className="text-lg font-bold">Worst Subject</h3>
                <p className="text-2xl text-red-600">{data.worstSubject}</p>
            </div>

            {/* Correct vs Incorrect */}
            <div className="bg-white shadow rounded-2xl p-4 col-span-2">
                <h3 className="text-lg font-bold mb-2">Most Correct vs Incorrect Questions</h3>
                <ResponsiveContainer width="100%" height={300}>
                    <LineChart data={data.correctIncorrect}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="question" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="correct" stroke="#82ca9d" />
                        <Line type="monotone" dataKey="incorrect" stroke="#ff4d4f" />
                    </LineChart>
                </ResponsiveContainer>
            </div>

            {/* Time Subject */}
            <div className="bg-white shadow rounded-2xl p-4">
                <h3 className="text-lg font-bold mb-2">Time Taken (Subjects)</h3>
                <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={data.timeSubject}>
                        <XAxis dataKey="subject" />
                        <YAxis />
                        <Tooltip />
                        <Bar dataKey="time" fill="#ffc658" />
                    </BarChart>
                </ResponsiveContainer>
            </div>

            {/* Time Question */}
            <div className="bg-white shadow rounded-2xl p-4">
                <h3 className="text-lg font-bold mb-2">Time Taken (Questions)</h3>
                <ResponsiveContainer width="100%" height={250}>
                    <LineChart data={data.timeQuestion}>
                        <XAxis dataKey="question" />
                        <YAxis />
                        <Tooltip />
                        <Line type="monotone" dataKey="time" stroke="#8884d8" />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        </>

    );
};

export default ExamAnalytics;
